import React from 'react';
import PropTypes from 'prop-types';

import { Wrap, StandardLogo, BLogo, RootLink } from './styled';

export default class HomeLink extends React.PureComponent {
    handleClick = (event) => {
        event.preventDefault();
        const { storeCode, language } = this.props;
        window.location = `/${storeCode}-${language}`;
    };

    renderLogo() {
        const { theme, isBusinessStore, isTransparent } = this.props;

        if (isBusinessStore) {
            return <BLogo color={theme.colors.Foreground} />;
        }

        if (isTransparent) {
            return <StandardLogo color={theme.colors.Background} />;
        }

        return <StandardLogo color={theme.name === 'dark' ? '#FFFFFF' : theme.colors.Color1} />;
    }

    render() {
        const { className, isLoggedIn, isBusinessStore } = this.props;
        const redirectionLink = isLoggedIn ? '/for-you' : '';

        if (isBusinessStore) {
            return (
                <RootLink className={className} href="#" onClick={this.handleClick}>
                    {this.renderLogo()}
                </RootLink>
            );
        }

        return (
            <Wrap className={className} to={redirectionLink} type="catalog-link">
                {this.renderLogo()}
            </Wrap>
        );
    }
}

HomeLink.propTypes = {
    className: PropTypes.string,
    theme: PropTypes.shape({
        colors: PropTypes.object,
    }).isRequired,
};

HomeLink.defaultProps = {
    className: '',
};
